import React, { useState } from "react";

const OngoingMonitoring = ({ data, updateData }) => {
  const [formState, setFormState] = useState(data || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formState, [name]: value };
    setFormState(updatedForm);
    updateData(updatedForm);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Ongoing Monitoring Data", formState);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="progressNotes"
            className="block text-gray-700 font-medium"
          >
            Progress Notes
          </label>
          <textarea
            id="progressNotes"
            name="progressNotes"
            value={formState.progressNotes || ""}
            onChange={handleChange}
            placeholder="Enter progress notes"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="labResults"
            className="block text-gray-700 font-medium"
          >
            Lab Test Results
          </label>
          <textarea
            id="labResults"
            name="labResults"
            value={formState.labResults || ""}
            onChange={handleChange}
            placeholder="Enter lab test results"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="medications"
            className="block text-gray-700 font-medium"
          >
            Medications Administered
          </label>
          <input
            type="text"
            id="medications"
            name="medications"
            value={formState.medications || ""}
            onChange={handleChange}
            placeholder="Enter medications administered"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="nextSteps"
            className="block text-gray-700 font-medium"
          >
            Next Steps/Procedures
          </label>
          <textarea
            id="nextSteps"
            name="nextSteps"
            value={formState.nextSteps || ""}
            onChange={handleChange}
            placeholder="Enter next steps or procedures"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <button
        type="submit"
        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
      >
        Save & Next
      </button>
    </form>
  );
};

export default OngoingMonitoring;
